import classNames from 'classnames';
import { format, isValid } from 'date-fns';

import { LaunchpadProject } from '@api';

import { formatNumberAsCurrency } from '@shared/helpers/formatters';

import PaymentIcons from '@launchpad/components/common/PaymentIcons/PaymentIcons';

import PoolStatList, { PoolStat } from '../OptionsCard/PoolStatList';

const LaunchInfoMultiPool = ({
  project,
  className,
}: {
  project: LaunchpadProject;
  className?: string;
}) => {
  const tokens = project.salePool.map((pool) => pool.attributes.depositTokenTicker);
  const isLiveOrAnnounced = project.salePool.some(
    (pool) => pool.attributes.status === 'SALE_STARTED' || pool.attributes.status === 'ANNOUNCED',
  );
  const isComingSoon = project?.attributes?.isComingSoon;
  const stats: PoolStat[] = [
    {
      id: 'start-date',
      label: 'START DATE',
      content:
        isValid(new Date(project.attributes.startDate)) && !isComingSoon
          ? format(new Date(project.attributes.startDate), 'dd.MM.yy, HH:mm')
          : 'COMING SOON',
      tooltip: 'Start date of the IDO.',
    },
    {
      id: 'raising-goal',
      label: 'Total RAISING GOAL',
      content: project?.meta?.goal ? formatNumberAsCurrency({ amount: project.meta.goal }) : 'TBA',
      tooltip: 'Total funds targeted to be raised across all pools in this IDO.',
    },
    {
      id: 'deposited',
      label: isLiveOrAnnounced ? 'DEPOSITED SO FAR' : 'TOTAL DEPOSITED',
      content: project?.meta?.deposited
        ? formatNumberAsCurrency({ amount: project.meta.deposited })
        : 'TBA',
      tooltip: 'Sum of deposits by all users across all pools to date.',
    },
  ];

  return (
    <div
      className={classNames(
        'border rounded-lg min-w border-primary-200 flex flex-col p-4 pt-8',
        className,
      )}
    >
      <PoolStatList items={stats} />

      <div className="flex flex-col gap-2 items-start mt-4">
        <span className="text-xs mr-auto font-semibold text-neutral-500">
          Network and payment method
        </span>

        <PaymentIcons tokens={tokens} />
      </div>
    </div>
  );
};

export default LaunchInfoMultiPool;
